/* ZOALIN_MOBILE_PDP_PRICE_DECISION_ROW_20260718 */
(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px), (orientation: landscape) and (max-height: 760px)');
  const rowClass = 'zoalin-mobile-pdp-decision-price';
  const hiddenTitleClass = 'zoalin-mobile-pdp-title-hidden';
  const collapsedHeaderClass = 'zoalin-mobile-pdp-header-collapsed';
  const reviewStyleId = 'zoalin-mobile-reviews-empty-text-position-20260719-js';
  const sourceSelector = '#MainContent .product-details product-price[data-block-id*="price"]';
  const detailsSelector = '#MainContent .product-details';
  const pickerSelector = '#MainContent .product-details variant-picker, #MainContent variant-picker';

  const sourcePrice = () => document.querySelector(sourceSelector);
  const productDetails = () => document.querySelector(detailsSelector);
  const variantPicker = () => document.querySelector(pickerSelector);

  const findDivider = () => {
    const details = productDetails();
    if (!details) return null;

    const candidates = Array.from(details.querySelectorAll('[data-block-id], [class], hr'));
    return candidates.find((node) => {
      const blockId = node.getAttribute?.('data-block-id') || '';
      const className = typeof node.className === 'string' ? node.className : '';
      return node.tagName === 'HR' || /divider/i.test(blockId) || /divider/i.test(className);
    }) || null;
  };

  const hideDuplicateTitle = () => {
    const details = productDetails();
    if (!details) return;

    if (!mediaQuery.matches) {
      details.querySelectorAll('[data-zoalin-mobile-pdp-title-hidden="true"]').forEach((node) => {
        node.classList.remove(hiddenTitleClass);
        node.style.display = '';
        node.removeAttribute('data-zoalin-mobile-pdp-title-hidden');
      });
      details.querySelectorAll('[data-zoalin-mobile-pdp-header-collapsed="true"]').forEach((node) => {
        node.classList.remove(collapsedHeaderClass);
        node.style.display = '';
        node.removeAttribute('data-zoalin-mobile-pdp-header-collapsed');
      });
      return;
    }

    details.querySelectorAll('h1').forEach((heading) => {
      if (heading.closest('.zoalin-mobile-product-masthead')) return;

      const target =
        heading.closest('text-block, .text-block, [data-testid="text-block"], [data-block-id^="text"], [data-block-id*="_text"], [data-block-id*="title"]') ||
        heading;

      target.classList.add(hiddenTitleClass);
      target.setAttribute('data-zoalin-mobile-pdp-title-hidden', 'true');
      target.style.display = 'none';

      const headerShell = target.closest('.group-block');
      if (headerShell && !headerShell.querySelector('variant-picker, buy-buttons, product-form, .product-form')) {
        headerShell.classList.add(collapsedHeaderClass);
        headerShell.setAttribute('data-zoalin-mobile-pdp-header-collapsed', 'true');
        headerShell.style.display = 'none';
      }
    });
  };

  const ensureRow = () => {
    const details = productDetails();
    const picker = variantPicker();
    if (!details && (!picker || !picker.parentElement)) return null;

    let row = document.querySelector('#MainContent .' + rowClass);
    if (!row) {
      row = document.createElement('div');
      row.className = rowClass;
      row.setAttribute('aria-live', 'polite');
      row.setAttribute('aria-label', 'Sale price with 20% discount');
    }

    const divider = findDivider();
    if (divider?.parentElement && row.nextElementSibling !== divider) {
      divider.parentElement.insertBefore(row, divider);
    } else if (picker?.parentElement && row.nextElementSibling !== picker) {
      picker.parentElement.insertBefore(row, picker);
    } else if (details && row.parentElement !== details) {
      details.prepend(row);
    }

    return row;
  };

  const addDiscountBadge = (container) => {
    container.querySelectorAll('.zoalin-price-discount-badge').forEach((badge) => badge.remove());

    const badge = document.createElement('span');
    badge.className = 'zoalin-price-discount-badge';
    badge.textContent = '20% OFF';
    badge.setAttribute('aria-label', '20% off');
    container.appendChild(badge);
  };

  const adjustReviewEmptyText = () => {
    if (!mediaQuery.matches) return;

    if (!document.getElementById(reviewStyleId)) {
      const style = document.createElement('style');
      style.id = reviewStyleId;
      style.textContent = [
        '/* ZOALIN_MOBILE_REVIEWS_EMPTY_TEXT_POSITION_20260719_V2 */',
        '@media(max-width:749px),(orientation:landscape) and (max-height:760px){',
        'html body.template-product #judgeme_product_reviews .jm-no-reviews-state{width:100%!important;max-width:100%!important;margin:-4px auto 0!important;justify-items:center!important;text-align:center!important;}',
        'html body.template-product #judgeme_product_reviews .jm-no-reviews-state__text{display:block!important;width:100%!important;max-width:100%!important;margin:-2px auto 0!important;text-align:center!important;transform:translateY(-4px)!important;}',
        'html body.template-product #judgeme_product_reviews .jm-no-reviews-state__action-buttons{justify-content:center!important;margin-top:6px!important;}',
        '}',
      ].join('');
      document.head.appendChild(style);
    }

    const root = document.querySelector('#judgeme_product_reviews');
    const state = root?.querySelector('.jm-no-reviews-state');
    const text = root?.querySelector('.jm-no-reviews-state__text');
    const actions = root?.querySelector('.jm-no-reviews-state__action-buttons');
    if (!state || !text) return;

    state.style.setProperty('width', '100%', 'important');
    state.style.setProperty('max-width', '100%', 'important');
    state.style.setProperty('margin', '-4px auto 0', 'important');
    state.style.setProperty('text-align', 'center', 'important');
    state.style.setProperty('justify-items', 'center', 'important');

    text.style.setProperty('display', 'block', 'important');
    text.style.setProperty('width', '100%', 'important');
    text.style.setProperty('max-width', '100%', 'important');
    text.style.setProperty('margin', '-2px auto 0', 'important');
    text.style.setProperty('text-align', 'center', 'important');
    text.style.setProperty('transform', 'translateY(-4px)', 'important');

    if (actions) {
      actions.style.setProperty('justify-content', 'center', 'important');
      actions.style.setProperty('margin-top', '6px', 'important');
    }
  };

  const sync = () => {
    const row = document.querySelector('#MainContent .' + rowClass);
    hideDuplicateTitle();
    adjustReviewEmptyText();

    if (!mediaQuery.matches) {
      row?.remove();
      return;
    }

    const source = sourcePrice();
    const container = source?.querySelector('[ref="priceContainer"]');
    const target = ensureRow();
    if (!container || !target) return;

    const clone = container.cloneNode(true);
    clone.classList.add('zoalin-mobile-pdp-price-container');
    clone.querySelectorAll('.price__hidden, .price__regular.price__hidden, style').forEach((node) => node.remove());
    addDiscountBadge(clone);

    target.replaceChildren(clone);
    target.hidden = false;
  };

  const scheduleSync = () => {
    [0, 80, 180, 420, 900, 1600].forEach((delay) => window.setTimeout(sync, delay));
  };

  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('load', scheduleSync);
  mediaQuery.addEventListener?.('change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);

  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('variant-picker')) scheduleSync();
  });

  document.addEventListener('shopify:product:select', (event) => {
    if (event.promise?.finally) event.promise.finally(scheduleSync);
    scheduleSync();
  });

  scheduleSync();
})();
